<script setup>
import Error404Icon from '@/Shared/SVG/Error404Icon';
import ButtonShape from '@/Shared/ButtonShape';
</script>

<template>
    <div class="mt-6 flex h-full flex-col lg:flex-row lg:space-x-6">
        <div class="relative w-full">
            <div class="m-auto text-center text-white">
                <div>
                    <Error404Icon class="w-full"></Error404Icon>
                </div>

                <p
                    class="cursor-default pt-6 text-2xl text-white text-opacity-60"
                >
                    {{ description }}
                </p>
                <div class="mt-6">
                    <ButtonShape type="blue" link="/">
                        <span>Head to the Homepage</span>
                    </ButtonShape>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        status: Number,
    },
    computed: {
        title() {
            return {
                503: 'Service Unavailable',
                500: 'Server Error',
                404: 'Page Not Found',
                403: 'Forbidden',
            }[this.status];
        },
        description() {
            return {
                503: 'Sorry, we are doing some maintenance. Please check back soon.',
                500: 'Whoops, something went wrong on our servers.',
                404: 'Sorry, the page you are looking for could not be found.',
                403: 'Sorry, you are forbidden from accessing this page.',
            }[this.status];
        },
    },
};
</script>
